playVideo = () => {
    const video = document.querySelector('#home-video')
    const wrapper = document.querySelector('#playButtonWrapper')

    wrapper.classList.add('dn')

    video.play()
    video.setAttribute("controls","controls")
}

function toggleIngredients(){
    document.querySelector('.ingredient-list').classList.toggle('show')
    document.querySelector('.description-arrow').classList.toggle('open')
}

toggleShow = (section, caller) => {
    document.querySelector(section).classList.toggle('show')
    caller.classList.toggle('open')
}

function scrollToSection(className){
    document.querySelector('.'+className).scrollIntoView({behavior: 'smooth'})
}

function changeCart(line){
    const value = document.getElementById(`itemQuantity${line}`).value;
    window.location = `/cart/change?line=${line}&quantity=${value}`
}

sharePinterest = (thumbnail, description) =>
    window.open(`https://pinterest.com/pin/create/button/?url=${window.location.href}&media=${thumbnail}&description=${description}`, '_blank')

shareTwitter = (description) =>
    window.open(`https://twitter.com/intent/tweet?url=${window.location.href}&via=into_inc&text=${description}`, '_blank')

shareFacebook = () =>
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, '_blank')

shareInstagram = () =>
    window.open(`https://instagram.com/_u/into_inc`, '_blank')

shareGeneric = (description) =>
    navigator.share
        ? navigator.share({
            title: description,
            url: window.location.href
            }).catch((e) => {
                console.log(e)
                alert('Share Dialogue not supported, please use browser share tools.')
            })
        : alert('Share Dialogue not supported, please use browser share tools.')

bookmarkPage = (title) =>
    window.external && ('AddFavorite' in window.external)
        ? window.external.AddFavorite(window.location.href, title)
        : window.sidebar && window.sidebar.addPanel
            ? window.sidebar.addPanel(title, window.location.href, '')
            : alert('Press ' + (/Mac/i.test(navigator.platform) ? 'Cmd' : 'Ctrl') + '+D to bookmark this page.')

function interceptCartClick(e) {
    const href = this.href

    populateCartModal(href)
    e.preventDefault()
    return false
}

populateCartModal = (url = '/cart') => {
    const cartContent = document.querySelector('.cart-content')

    fetch(url).then(function (response) {
        return response.text();
    }).then(function (html) {

        // Convert the HTML string into a document object
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cartSection = doc.querySelector('.cart-section')

        if(cartSection){
            cartContent.innerHTML = cartSection.outerHTML
            const cartButtons = document.querySelectorAll('.cart-content .changeCartBtn')
            cartButtons.forEach(cartButton => cartButton.addEventListener('click', interceptCartClick) )

            fetchCartCount()
        }

    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });
}

openCartModal = () => {
    populateCartModal()
    document.querySelector('#cartModal').classList.add('show')
    return false;
}
closeCartModal = () => document.querySelector('#cartModal').classList.remove('show')

fetchCartCount = () => {
    console.log('fetching')
    fetch('/cart.json').then(function (response) {
        return response.json();
    }).then(function (json){
        console.log('json',json)
        updateCartCount(json.items)
    }).catch(function (err) {
        console.error('Something went wrong.', err);
    })
}

updateCartCount = items => {
    const count = items.reduce((total, item) => total + item.quantity, 0)

    window.siteData.cart.item_count = count
    vueApp.setCartCount(count)
}

handleCartSubmit = (form) => {
    const url = '/cart/add.json'//form.action
    const formData = new FormData(form)
    const data = {
        'items': [ Object.fromEntries([...formData]) ]
    }

    fetch(url, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    }).then(function (response) {
        return response.json();
    }).then(function (json){
        updateCartCount(json.items)
        openCartModal();
    }).catch(function (err) {
        console.error('Something went wrong.', err);
    })

    return false
}